/* SB · Kampagneside: læg i kurv, produktvindue og opskriftsslider. Virker for alle .sbk-sektioner på siden. */
(function () {
  if (window.sbkInit) return;
  window.sbkInit = true;

  /* ---------- læg i kurv → temaets kurv-skuffe ---------- */
  function addToCart(variantId, btn) {
    if (!variantId || (btn && btn.disabled)) return;
    var routes = (window.FoxTheme && FoxTheme.routes) || {};
    var url = routes.cart_add_url || '/cart/add.js';
    if (btn) btn.disabled = true;
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data && data.status && data.status >= 400) throw new Error(data.description || 'error');
      if (btn) {
        var label = btn.getAttribute('data-label') || btn.textContent;
        btn.setAttribute('data-label', label);
        btn.classList.add('is-added');
        btn.textContent = btn.getAttribute('data-added') || label;
        setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; btn.disabled = false; }, 1400);
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
    }).catch(function () {
      if (btn) {
        var label = btn.getAttribute('data-label') || btn.textContent;
        btn.setAttribute('data-label', label);
        btn.textContent = btn.getAttribute('data-error') || label;
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2000);
      }
    });
  }

  /* ---------- produktvindue ---------- */
  var openModal = null, lastFocus = null;
  function closeModal() {
    if (!openModal) return;
    openModal.modal.hidden = true;
    openModal.scrim.hidden = true;
    openModal = null;
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  function quickView(section, index) {
    var dataEl = section.querySelector('[data-sbk-products]');
    var modal = section.querySelector('[data-sbk-modal]');
    var scrim = section.querySelector('[data-sbk-scrim]');
    if (!dataEl || !modal || !scrim) return;
    var list;
    try { list = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var p = list[index];
    if (!p) return;
    var img = modal.querySelector('[data-qv-img]');
    img.src = p.img || ''; img.alt = p.name;
    modal.querySelector('[data-qv-name]').textContent = p.name;
    modal.querySelector('[data-qv-price]').innerHTML = '<b>' + p.price + '</b>' + (p.compare ? '<s>' + p.compare + '</s>' : '');
    var badges = modal.querySelector('[data-qv-badges]');
    badges.innerHTML = '';
    (p.badges || []).forEach(function (b) {
      var s = document.createElement('span');
      s.className = 'sbk-badge' + (b.red ? ' sbk-badge--red' : '');
      s.textContent = b.text;
      badges.appendChild(s);
    });
    var add = modal.querySelector('[data-qv-add]');
    add.setAttribute('data-variant', p.variant);
    add.disabled = !p.available;
    modal.querySelector('[data-qv-link]').href = p.url;
    lastFocus = document.activeElement;
    modal.hidden = false; scrim.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    openModal = { modal: modal, scrim: scrim };
    var x = modal.querySelector('[data-sbk-close]');
    if (x) x.focus();
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('.sbk [data-sbk-add]');
    if (add) {
      e.preventDefault();
      var inModal = add.closest('[data-sbk-modal]');
      addToCart(add.getAttribute('data-variant'), inModal ? null : add);
      if (inModal) closeModal();
      return;
    }
    var qv = e.target.closest('.sbk [data-sbk-qv]');
    if (qv) {
      e.preventDefault();
      quickView(qv.closest('.sbk'), Number(qv.getAttribute('data-sbk-qv')));
      return;
    }
    if (e.target.closest('.sbk [data-sbk-close]') || e.target.matches('.sbk [data-sbk-scrim]')) closeModal();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  /* ---------- opskriftsslider: pile + træk med musen (touch bruger native scroll) ---------- */
  function initTrack(root) {
    var track = root.querySelector('[data-sbk-track]');
    if (!track || track.dataset.sbkReady) return;
    track.dataset.sbkReady = '1';
    var step = function () { var r = track.querySelector('.sbk-r'); return r ? r.offsetWidth + parseFloat(getComputedStyle(track).columnGap || 18) : track.clientWidth; };
    var snapTo = function (i) {
      var max = track.scrollWidth - track.clientWidth;
      track.scrollTo({ left: Math.max(0, Math.min(max, i * step())), behavior: 'smooth' });
    };
    var prev = root.querySelector('[data-sbk-prev]'), next = root.querySelector('[data-sbk-next]');
    if (prev) prev.addEventListener('click', function () { snapTo(Math.round(track.scrollLeft / step()) - 1); });
    if (next) next.addEventListener('click', function () { snapTo(Math.round(track.scrollLeft / step()) + 1); });

    var down = false, sx = 0, sl = 0, moved = 0, lastX = 0, lastT = 0, vel = 0, t;
    track.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      down = true; moved = 0; vel = 0; sx = lastX = e.clientX; sl = track.scrollLeft; lastT = performance.now();
      clearTimeout(t);
      e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 6) track.classList.add('is-drag');
      var now = performance.now(); vel = (e.clientX - lastX) / Math.max(1, now - lastT); lastX = e.clientX; lastT = now;
      moved = Math.abs(dx);
      track.scrollLeft = sl - dx;
    });
    window.addEventListener('mouseup', function () {
      if (!down) return;
      down = false;
      if (moved <= 6) { track.classList.remove('is-drag'); return; }
      var i = track.scrollLeft / step();
      i = Math.abs(vel) > 0.3 ? (vel < 0 ? Math.ceil(i) : Math.floor(i)) : Math.round(i);
      snapTo(i);
      t = setTimeout(function () { track.classList.remove('is-drag'); }, 450);
    });
    track.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }
  function initAll() { document.querySelectorAll('.sbk').forEach(initTrack); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
